/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import {
  LISTING_SUMMARY,
  DEMAND_LISTING_SUMMARY_SUBSCRIPTION,
  OFFER_LISTING_SUMMARY_SUBSCRIPTION,
} from 'pages/Dashboard/components/DashboardGraphQL';
import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
import { OFFER_AND_DEMAND } from 'helper/constants';
import Loader from 'components/common/Loader';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';

const NewListingCount = ({ item, selectedOption, canView = true }) => {
  const navigate = useNavigate();
  const { data, loading, error, subscribeToMore } = useQuery(LISTING_SUMMARY, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
    skip: !canView,
  });

  useEffect(() => {
    if (!canView) return undefined;
    const unsubscribe1 = subscribeToMore({
      document: OFFER_LISTING_SUMMARY_SUBSCRIPTION,
      variables: defaultFiltersForDates(selectedOption),

      updateQuery: (prev, { subscriptionData }) => {
        // if (!prev || isEmpty(prev)) return '';
        // if (!subscriptionData.data) return prev;
        if (subscriptionData?.data?.listingsSummaryOffer) {
          return {
            listingsSummary: { ...subscriptionData.data.listingsSummaryOffer },
          };
        }
      },
    });

    const unsubscribe = subscribeToMore({
      document: DEMAND_LISTING_SUMMARY_SUBSCRIPTION,
      variables: defaultFiltersForDates(selectedOption),

      updateQuery: (prev, { subscriptionData }) => {
        // if (!prev || isEmpty(prev)) return '';
        // if (!subscriptionData.data) return prev;
        if (subscriptionData?.data?.listingsSummaryDemand) {
          return {
            listingsSummary: { ...subscriptionData.data.listingsSummaryDemand },
          };
        }
      },
    });

    return () => {
      unsubscribe();
      unsubscribe1();
    };
  }, [canView, selectedOption, subscribeToMore]);

  if (!canView) {
    return (
      <div>
        <Card className="border-0">
          <CardBody>
            <h4 className="f-16 fw-semibold mb-3">{item.title}</h4>
            <PermissionNotice message="You do not have permission to view Listings." />
          </CardBody>
        </Card>
      </div>
    );
  }

  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Card className="border-0 cursor-pointer">
        <CardBody>
          <h4 className="f-16 fw-semibold mb-3">{item.title}</h4>
          {loading ? (
            <div className="text-center mt-4">
              <Loader size="sm" />
            </div>
          ) : (
            <Row className="justify-content-between">
              <Col key={item.subTitle[0].label}>
                <div>
                  <p className="text-active-light mb-0">
                    {item.subTitle[0].label}
                  </p>
                  <p
                    className="mb-0 f-18 fw-medium"
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate('/market-listing', {
                        state: { value: OFFER_AND_DEMAND.OFFERS },
                      });
                    }}
                    aria-hidden="true"
                  >
                    {data?.listingsSummary?.offers === null
                      ? 0
                      : data?.listingsSummary?.offers}
                  </p>
                </div>
              </Col>
              <Col key={item.subTitle[1].label}>
                <div>
                  <p className="text-active-light mb-0">
                    {item.subTitle[1].label}
                  </p>
                  <p
                    className="mb-0 f-18 fw-medium text-start"
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate('/market-listing', {
                        state: { value: OFFER_AND_DEMAND.DEMANDS },
                      });
                    }}
                    aria-hidden="true"
                  >
                    {data?.listingsSummary?.demands === null
                      ? 0
                      : data?.listingsSummary?.demands}
                  </p>
                </div>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default NewListingCount;
